export class LotNoReq{
    lotNumber:string;
}